import Mapgl from './Mapgl';
import { MapglContextProvider } from './MapglContext';
import { GeolocationControl } from './GeolocationControl';

function App() {
    return (
        <MapglContextProvider>
            <div className='App-map-container'>
                <Mapgl />
                <GeolocationControl />
            </div>
        </MapglContextProvider>
    );
}

export default App;
